import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactDOM from "react-dom";
import { Helmet } from "react-helmet"

import Seo from "./seo";
import { AppCtaMobileWrapper } from "./AppCTABanner/staticDataWrapper";

import Theme from "@airasia/phoenix-components/components/Theme";
import UniversalHeader from "@airasia/phoenix-widgets/widgets/UniversalHeader";
import UniversalFooter from "@airasia/phoenix-widgets/widgets/UniversalFooter";
import HeroBanner from "@airasia/phoenix-widgets/widgets/HeroBanner";
import Breadcrumb from "./breadcrumb";

import UNIVERSAL_HEADER_DATA from "../data/phoenix/universalHeader";
import UNIVERSAL_FOOTER_DATA from "../data/phoenix/universalFooter";
import { fireGtmEvent, getGtmUserType } from "../utils/functions";
import { GTM_PROJECT_CATEGORY } from "../utils/constants";
import WebVitalRUM from "@airasia/phoenix-components/components/WebVitalRUM";
import pic from "../images/hero-banner-generic-en.jpeg";


const Wrapper = styled.div`
    max-width: 625px;
    margin: 0 16px 24px;

    @media only screen and (min-width: 720px) {
      width: 90%;
      max-width: 976px;
      margin: 0 auto 48px;
    }

    @media only screen and (min-width: 1025px) {
      width: 90%;
      max-width: 1224px;
      margin: 0 auto 48px;
    }

    #breadcustom a:nth-child(2) {
      display: none;
    }
  `;

const BannerWrapper = styled.div`
      margin-bottom: 16px;

    @media only screen and (min-width: 768px) {
      margin: 32px auto;
      max-width: 1272px;
    }
  `;

const MobileContainer = styled.div`
    @media only screen and (min-width: 768px) {
      display: none;
    }
  `;

const DesktopContainer = styled.div`
    @media only screen and (max-width: 768px) {
      display: none;
    }
  `;

const Layout = ({ pageData, dataHrefLang, children }) => {
  console.log('pageData -- ', pageData)
  const CSData = pageData;
  let selectedLocale = CSData.seo_tags.oglocale;
  const hrefLang = dataHrefLang;
  const { breadcrumb } = CSData;
  let universalHeaderData = UNIVERSAL_HEADER_DATA;
  if (CSData.localization[0].default) {
    let localization = CSData.localization;
    localization.forEach((locale, index) => {
      localization[index].default = locale.default;
    });
    universalHeaderData.localeList = [
      {
        data: [...localization],
      },
    ];
  } else {
    let defaultLocaleList = [
      {
        default: CSData.url,
        shortform: selectedLocale.split("-")[0],
        longform: CSData.title,
      },
    ];
    universalHeaderData.localeList = [
      {
        data: [...defaultLocaleList],
      },
    ];
  }

  const HERO_BANNER_DATA =
    CSData.banner &&
    CSData.banner.map((x) => {
      return {
        altText: (x.alltext),
        bannerID: x.bannerid,
        // desktopImage:
        //  (x.desktopimageurl ? x.desktopimageurl : x.desktopimage) +
        //  "?width=1270&height=280&quality=85&format=jpg&auto=webp",
        // mobileImage:
        //  (x.mobileimageurl ? x.mobileimageurl : x.mobileimage) +
        //  "?height=200&quality=80&format=jpg&auto=webp",
        // redirectUrl: x.redirecturl,
        // tabletImage:
        //  (x.tabletimageurl ? x.tabletimageurl : x.tabletimage) +
        //  "?width=720&quality=80&format=jpg&auto=webp",

        desktopImage:
          (x.desktopimageurl ? x.desktopimageurl : x.desktopimage),
        mobileImage:
          (x.mobileimageurl ? x.mobileimageurl : x.mobileimage),
        redirectUrl: x.redirecturl,
        id: x.bannerid,
        tabletImage:
          (x.tabletimageurl ? x.tabletimageurl : x.tabletimage),
      };
    });

  return (
    <Theme theme="AIRASIA_CLASSIC">
      <Helmet>
        <script
          src="https://www.airasia.com/promotions/ct-promotion.js"
          crossorigin="anonymous"
        />
      </Helmet>

      <Seo
        data={CSData.seo_tags}
        faq={CSData.faq.faq}
        hrefLangData={hrefLang}
        url={CSData.url}
        breadcrumb={breadcrumb}
      />
      <WebVitalRUM fireGtm={fireGtmEvent} />
      <DesktopContainer>
        <UniversalHeader
          data={UNIVERSAL_HEADER_DATA}
          locale={selectedLocale}
          currency="MYR"
          environment="production"
          viewport="desktop"
          loginConfig={{
            HideLoginIconForMobile: false,
            enableBigPoints: false,
            reloadOnLoginStatusChange: true,
            shouldSetCookie: false,
          }}
        />
        <BannerWrapper>
          <HeroBanner
            bannerDetails={HERO_BANNER_DATA}
            device="desktop"
            gtmParameters={{
              event: "trackEventNoEcommerce",
              eventActionClick: "click",
              eventActionView: "view",
              eventCategory: "{{consumername}} | herobanner",
              eventLabelCardClick: " {{bannerid}} | {{bannerposition}} ",
              eventLabelHeadlineClick: "",
              eventLabelView: `{{bannerid}} | ${getGtmUserType()} | {{bannerposition}} | {{bannerorder}}`,
            }}
            onBannerClick={(obj) => {
              fireGtmEvent(obj);
            }}
            gtmConsumerName={GTM_PROJECT_CATEGORY}
            fireGtm={fireGtmEvent}
            customProperties={{
              id: "#hero-test2xx",
            }}
          />
        </BannerWrapper>
      </DesktopContainer>
      <MobileContainer>
        <UniversalHeader
          data={UNIVERSAL_HEADER_DATA}
          locale={selectedLocale}
          currency="MYR"
          environment="production"
          viewport="mobile"
          loginConfig={{
            HideLoginIconForMobile: false,
            enableBigPoints: false,
            reloadOnLoginStatusChange: true,
            shouldSetCookie: false,
          }}
        />
        <BannerWrapper>
          <HeroBanner
            bannerDetails={HERO_BANNER_DATA}
            device="mobile"
            gtmParameters={{
              event: "trackEventNoEcommerce",
              eventActionClick: "click",
              eventActionView: "view",
              eventCategory: "{{consumername}} | herobanner",
              eventLabelCardClick: " {{bannerid}} | {{bannerposition}} ",
              eventLabelHeadlineClick: "",
              eventLabelView: `{{bannerid}} | ${getGtmUserType()} | {{bannerposition}}`,
            }}
            onBannerClick={(obj) => {
              fireGtmEvent(obj);
            }}
            gtmConsumerName={GTM_PROJECT_CATEGORY}
            fireGtm={fireGtmEvent}
          />
        </BannerWrapper>
      </MobileContainer>

      <Wrapper>
        {breadcrumb && (
          <div id="breadcustom" style={{ marginTop: "2%" }}>
            <Breadcrumb crumbs={breadcrumb} />
          </div>
        )}
        {children}
      </Wrapper>

      <MobileContainer>
        {AppCtaMobileWrapper["/"]}
        <UniversalFooter viewport="mobile" data={UNIVERSAL_FOOTER_DATA} />
      </MobileContainer>
      <DesktopContainer>
        <UniversalFooter viewport="desktop" data={UNIVERSAL_FOOTER_DATA} />
      </DesktopContainer>
    </Theme>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
